import { useParams } from 'react-router-dom'
import { CoinSymbolToName } from '../util/CoinUtil'

export const CoinCrumb = () => {
  const { coin } = useParams()
  if (!coin) return null
  const name = CoinSymbolToName[coin.toUpperCase()]
  return <>{name}</>
}
